import { render, staticRenderFns } from "./penggunaan_form.vue?vue&type=template&id=5a963d4e&"
import script from "./penggunaan_form.vue?vue&type=script&lang=js&"
export * from "./penggunaan_form.vue?vue&type=script&lang=js&"
import style0 from "./penggunaan_form.vue?vue&type=style&index=0&id=5a963d4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports